export enum EDenoisedSamplesType {
  ECG = 'ECG',
  PCG = 'PCG',
  PPG = 'PPG',
}
